export default __webpack_public_path__ + "static/media/projTrack4Full.85af6252.png";